/* HF Buy Box — metre-first quantity/total logic (hybrid product templates).
   Document-level event delegation: survives Horizon section morphs/hydration.

   Behaviour contract (v7, 10 Jul 2026):
   - Area typed  -> boxes = ceil(area x 1.1 / m2) when wastage ticked (default),
     ceil(area / m2) when not; wastage crossing no box boundary still adds one
     box (matches the quote engine).
   - Stepper +/- -> box count is literal; the covered area mirrors into the
     area field so the two inputs never contradict. The wastage checkbox is
     NEVER changed by code — only the customer toggles it.
   - Wastage toggle always visibly changes the count (nudges one box on
     rounding overlap). With no area entered it focuses the area field and a
     hint explains itself; a second hint invites re-adding wastage when it is
     manually unticked. */
(function () {
  if (window.__hfbBound) return;
  window.__hfbBound = true;

  function money(n) {
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function cardOf(el) {
    return el && el.closest ? el.closest('.hfb-card') : null;
  }
  function els(card) {
    var sid = card.id.slice(4); // strip "hfb-"
    return {
      area: document.getElementById('hfb-area-' + sid),
      boxes: document.getElementById('hfb-boxes-' + sid),
      waste: document.getElementById('hfb-waste-' + sid),
      coverage: document.getElementById('hfb-coverage-' + sid),
      total: document.getElementById('hfb-total-' + sid),
      savings: document.getElementById('hfb-savings-' + sid),
      savingsAmt: document.getElementById('hfb-savings-amt-' + sid),
      afterpay: document.getElementById('hfb-afterpay-' + sid),
      afterpayAmt: document.getElementById('hfb-afterpay-amt-' + sid),
      qty: document.getElementById('hfb-qty-' + sid)
    };
  }
  // Wastage only applies to the area->boxes conversion, so grey it out and
  // disable it whenever no area is entered (otherwise the control looks dead).
  function syncWaste(card) {
    var e = els(card);
    if (!e.waste || !e.area) return;
    var hasArea = parseFloat(e.area.value) > 0;
    e.waste.disabled = false;
    var label = e.waste.closest('label');
    if (!label) return;
    var msg = '';
    if (!hasArea) {
      msg = ' \u2014 enter your area above to apply';
    } else if (!e.waste.checked) {
      msg = ' \u2014 tick to add 10% for cuts';
    }
    var hint = label.querySelector('.hfb-waste-hint');
    if (msg) {
      if (!hint) {
        hint = document.createElement('em');
        hint.className = 'hfb-waste-hint';
        hint.style.opacity = '0.6';
        hint.style.fontStyle = 'normal';
        hint.style.fontSize = '0.85em';
        var span = label.querySelector('span');
        (span || label).appendChild(hint);
      }
      hint.textContent = msg;
    } else if (hint && hint.parentNode) {
      hint.parentNode.removeChild(hint);
    }
  }

  // Quote-only cards: carry the entered area (+boxes) onto the "Request a quote"
  // link so /pages/request-a-quote can pre-fill the m² field.
  function updateQuoteLink(card, area, boxes) {
    var link = card.querySelector('.quote-request-button');
    if (!link) return;
    try {
      var u = new URL(link.getAttribute('href'), window.location.origin);
      if (area && area > 0) { u.searchParams.set('sqm', area); } else { u.searchParams.delete('sqm'); }
      if (boxes) { u.searchParams.set('boxes', boxes); }
      link.setAttribute('href', u.pathname + '?' + u.searchParams.toString());
    } catch (err) {}
  }

  function recalc(card, fromArea, mirrorArea) {
    if (!card) return;
    var e = els(card);
    syncWaste(card);
    var isQuote = card.dataset.quote === '1';
    if (!e.area) return;
    if (!isQuote && (!e.total || !e.qty)) return;

    var m2 = parseFloat(card.dataset.m2PerBox) || 1;
    var price = parseFloat(card.dataset.boxPrice) || 0;
    var cmp = parseFloat(card.dataset.comparePrice) || 0;
    var boxes = parseInt(card.dataset.boxes || '1', 10);
    var area = parseFloat(e.area.value);
    if (fromArea && !(area > 0)) fromArea = false;

    if (fromArea) {
      var adjusted = e.waste.checked ? area * 1.1 : area;
      boxes = Math.ceil(adjusted / m2);
      // Wastage always adds at least one box, matching the quote engine.
      if (e.waste.checked && boxes === Math.ceil(area / m2)) boxes += 1;
    }
    boxes = Math.max(1, boxes);
    card.dataset.boxes = boxes;

    e.boxes.textContent = boxes + (boxes === 1 ? ' box' : ' boxes');
    if (e.qty) e.qty.value = boxes;

    var covers = boxes * m2;
    if (!fromArea && mirrorArea && e.area) {
      // Boxes drive: mirror the covered area into the area field so the two
      // inputs never contradict each other (competitor-style two-way sync).
      area = Math.round(covers * 100) / 100;
      e.area.value = area;
      syncWaste(card);
    }
    if (fromArea && area > 0) {
      e.coverage.textContent = 'Covers ' + covers.toFixed(2) + ' m² — enough for your ' + area + ' m²' + (e.waste.checked ? ' plus cuts' : '');
    } else {
      e.coverage.textContent = 'Covers ' + covers.toFixed(2) + ' m²';
    }

    if (isQuote) { updateQuoteLink(card, area, boxes); return; }

    var total = Math.round(boxes * price * 100) / 100;
    e.total.textContent = money(total);

    if (e.savings && e.savingsAmt && cmp > price) {
      var save = Math.round(boxes * (cmp - price) * 100) / 100;
      e.savingsAmt.textContent = money(save);
      e.savings.hidden = save <= 0;
    }

    if (e.afterpay && e.afterpayAmt) {
      if (total > 0 && total <= 2000) {
        e.afterpay.hidden = false;
        e.afterpayAmt.textContent = money(Math.round(total / 4 * 100) / 100);
      } else {
        e.afterpay.hidden = true;
      }
    }
  }

  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (t && /^hfb-area-/.test(t.id || '')) recalc(cardOf(t), true);
  });
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && /^hfb-waste-/.test(t.id || '')) {
      var card = cardOf(t);
      if (!card) return;
      var area = document.getElementById('hfb-area-' + card.id.slice(4));
      var hasArea = !!(area && parseFloat(area.value) > 0);
      var before = parseInt(card.dataset.boxes || '1', 10);
      recalc(card, hasArea);
      // The toggle must always visibly change the count. If re-deriving from
      // the area lands on the same number (rounding overlap), nudge one box
      // in the toggle's direction: wastage on only ever adds, off only removes.
      if (hasArea && parseInt(card.dataset.boxes || '1', 10) === before) {
        card.dataset.boxes = Math.max(1, before + (t.checked ? 1 : -1));
        recalc(card, false);
      }
      if (!hasArea && area) area.focus();
    }
  });
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('.hfb-step') : null;
    if (!btn) return;
    var card = cardOf(btn);
    if (!card) return;
    var boxes = parseInt(card.dataset.boxes || '1', 10);
    boxes += /^hfb-plus-/.test(btn.id) ? 1 : -1;
    card.dataset.boxes = Math.max(1, boxes);
    recalc(card, false, true);
  });

  function hfbInitWaste() {
    var cards = document.querySelectorAll('.hfb-card');
    for (var i = 0; i < cards.length; i++) syncWaste(cards[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hfbInitWaste);
  } else {
    hfbInitWaste();
  }
  document.addEventListener('shopify:section:load', hfbInitWaste);
})();
